import styles from './no-rows.module.scss';

export default function NoRowsOverlay() {
  return (
    <div className={styles['no-rows']}>
      <div className={styles.text}>
        There are no contract lines for this filter set.
        <br />
        Try to change filter
      </div>
    </div>
  );
}
